<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header" row wrap align-content-center justify-center>
        <v-flex xs12 lg4>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-users</v-icon>
              Todos os alunos
            </h1>
          </v-layout>
        </v-flex>
        <v-flex xs12 lg8>
          <v-layout row wrap justify-end>
            <v-text-field v-model="search" class="search-input" label="Buscar"
              append-icon="fal fa-search"></v-text-field>
            <v-btn round depressed large color="success" dark
              v-modal-trigger="'newUserDialog'">
              Cadastrar novo
              <v-icon small right>fal fa-plus-circle</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <section>
      <p class="section-filters">
        <span class="filter-title">Filtros:</span>
        <span v-bind:class="{ active: currentFilter == 'all' && currentRoles != 'admin' }"
          @click="filterBy('all')">Todos</span>  |
        <span v-bind:class="{ active: currentFilter == 'active' }"
          @click="filterBy('active')">Ativos</span>  |
        <span v-bind:class="{ active: currentFilter == 'pending' }"
          @click="filterBy('pending')">Pedentes</span>  |
        <span v-bind:class="{ active: currentFilter == 'confirmed' }"
          @click="filterBy('confirmed')">Incompletos</span>  |
        <span v-bind:class="{ active: currentRoles == 'admin' }"
          @click="filterBy('all', 'admin')">Admin</span>
      </p>
    </section>

    <empty-alert :icon="'users'" :color="'orange accent-4'" v-if="!users.length">
      <div slot="content">
        <p><strong>Nenhum aluno cadastrado.</strong></p>
      </div>
    </empty-alert>

    <v-flex xs12 class="section-box" v-if="users.length">
      <v-data-table
        width="100%"
        :headers="headers"
        :items="users"
        :search="search"
        sort-icon="fal fa-arrow-down"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>
            <router-link :to="{ name: 'AdminUserShow', params: { id: props.item._id }}">
              <v-avatar size="32" style="margin-right: 5px;">
                <img :src="props.item.avatar" height="32" v-if="props.item.avatar">
                <v-icon color="grey lighen-4" v-else>fal fa-user-circle</v-icon>
              </v-avatar>
              {{ props.item.full_name }}
            </router-link>
          </td>
          <td>{{ props.item.email }}</td>
          <td>
            <span v-if="props.item.phones && props.item.phones[0]">
              {{ props.item.phones[0] }}
            </span>
            <span v-else>-</span>
          </td>
          <td>
            <v-tooltip bottom>
              <span slot="activator">{{ props.item.created_at | moment('from', 'now') }}</span>
              <span>{{ props.item.created_at | moment('DD/MM/Y, HH:mm') }}</span>
            </v-tooltip>
          </td>
          <td>
            <user-plan-label :plan="props.item.plan"></user-plan-label>
          </td>
          <td>
            <user-status-label v-if="props.item.status" :status="props.item.status"></user-status-label>
            <span v-else>-</span>
          </td>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="info" outline icon="fal fa-users">
            Nenhum aluno encontrado.
          </v-alert>
        </template>
        <template slot="no-data">
          <div class="my-3 text-xs-center">
            Nenhum aluno encontrado.
          </div>
        </template>
      </v-data-table>
    </v-flex>
    <admin-dialog-new-user></admin-dialog-new-user>
  </v-layout>
</template>

<script>
import router from '@/router'
import axios from 'axios'
import UserStatusLabel from '@/modules/UserStatusLabel'
import AdminDialogNewUser from '@/components/admin/AdminDialogNewUser'
import UserPlanLabel from '@/modules/UserPlanLabel'
import EventBus from '@/event-bus'

export default {
  name: 'AdminUsers',
  data: () => ({
    currentFilter: 'all',
    search: '',
    currentRoles: '',
    headers: [
      { text: 'Aluno', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Contato', value: 'phone' },
      { text: 'Data do cadastro', value: 'created_at' },
      { text: 'Plano', value: 'plan' },
      { text: 'Status', value: 'status' }
    ],
    users: []
  }),

  methods: {
    filterBy (filter, roles = 'user') {
      this.currentFilter = filter
      this.currentRoles = roles

      if (filter === 'all') {
        this.loadAllUsers(null, roles)
      } else {
        this.loadAllUsers(filter, roles)
      }
    },

    showUser (id) {
      router.push({ name: 'AdminUserShow', params: { id: id } })
    },

    loadAllUsers (status = '', roles = 'user') {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      let path = `${API.users}/?roles=${roles}`

      if (status) {
        path = path + '&status=' + status
      }

      axios.get(path, this.user).then(response => {
        this.users = response.data.users
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar os usuários',
          color: 'error'
        })
        EventBus.$emit('appLoading', false)
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadUsers')
  },

  created () {
    this.loadAllUsers()
    EventBus.$on('loadUsers', this.loadAllUsers)
  },

  components: {
    'user-status-label': UserStatusLabel,
    'admin-dialog-new-user': AdminDialogNewUser,
    'user-plan-label': UserPlanLabel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUsers.vue